module.exports = __webpack_public_path__ + "img/Teilblockiert.8cfab422.svg";